<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="facility">{{ 'FACILITIES.FACILITIES_FORM.EDIT_FACILITY' | translate }}</span>
    <span *ngIf="!facility">{{ 'FACILITIES.FACILITIES_FORM.ADD_FACILITY' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<ng-scrollbar class="modal-body ps">
  <form id="industries-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="form-group">
      <label>{{ 'FACILITIES.FACILITIES_FORM.NAME' | translate }}</label>
      <input type="text" class="form-control" formControlName="name" />
    </div>
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" formControlName="active" />
      <label class="form-check-label">{{ 'FACILITIES.FACILITIES_FORM.ACTIVE' | translate }}</label>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="industries-form" [disabled]="form.invalid">
    {{ 'FACILITIES.FACILITIES_FORM.SAVE' | translate }}
  </button>
</div>
